import ContactForm from "./components/contact-form";
import DetailsInfo from "./components/details-info";
import SEO, { lawOfficeSchema } from '../../components/seo';

export default function ContactUs(){
    return(
        <div className="mb-10 min-h-screen bg-[#090909] py-12 text-zinc-300">
            <SEO
                title="Contact Quilaton Law Office | Cebu City"
                description="Contact Quilaton Law Office in Cebu City to discuss your legal concerns or schedule a consultation."
                path="/contact/"
                schema={lawOfficeSchema}
            />
            <p className="mx-auto mb-10 mt-2 flex max-w-4xl items-center justify-center px-5 text-center text-xl leading-8 text-zinc-400">We aim to respond to all inquiries within 24 hours. Your satisfaction is our priority, and we appreciate your interest in our services.</p>
            <ContactForm/>
            <DetailsInfo/>
        </div>
    );
}
